import React, { useEffect, useRef } from 'react';

const chats = [
  { who: 'H', text: 'Abi tak jaag rhi ho? 🌙', time: '11:45 PM', side: 'sent', delay: 0.2 },
  { who: 'F', text: 'Haan 😊 nend nahi aa rhi', time: '11:46 PM', side: 'received', delay: 0.5 },
  { who: 'H', text: 'Mujhe bhi 😂 baatein karein?', time: '11:47 PM', side: 'sent', delay: 0.8 },
  { who: 'F', text: 'Haan kyun nahi! ✨', time: '11:48 PM', side: 'received', delay: 1.1 },
  { who: 'H', text: 'Yeh raat khubsoorat hai na 🌟', time: '11:52 PM', side: 'sent', delay: 1.4 },
  { who: 'F', text: 'Haan especially jab acha conversation ho 💕', time: '11:53 PM', side: 'received', delay: 1.7 },
  { who: 'H', text: 'Goodnight Fiza 😊🌙', time: '2:30 AM', side: 'sent', delay: 2.0 },
  { who: 'F', text: 'Goodnight Hassan! Sweet dreams 💫', time: '2:31 AM', side: 'received', delay: 2.3 },
];

export default function LateNightSection() {
  return (
    <section id="late-night" style={{
      padding: 'clamp(60px, 10vw, 120px) 24px',
      background: 'linear-gradient(180deg, #0d0a14 0%, #080612 100%)',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Starfield background */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
        {Array.from({ length: 40 }).map((_, i) => (
          <div key={i} style={{
            position: 'absolute',
            width: Math.random() * 3 + 1,
            height: Math.random() * 3 + 1,
            borderRadius: '50%',
            background: `rgba(255,255,255,${Math.random() * 0.6 + 0.1})`,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animation: `twinkle ${2 + Math.random() * 3}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 3}s`,
          }} />
        ))}
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 60, alignItems: 'center',
        }}>
          {/* Instagram Chat UI */}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{
              width: '100%', maxWidth: 320,
              background: '#1a1228',
              border: '1px solid rgba(255,107,157,0.2)',
              borderRadius: 24,
              overflow: 'hidden',
              boxShadow: '0 30px 80px rgba(0,0,0,0.5), 0 0 40px rgba(168,85,247,0.1)',
            }}>
              {/* Header */}
              <div style={{
                padding: '16px 20px',
                background: 'linear-gradient(135deg, rgba(168,85,247,0.2), rgba(255,107,157,0.1))',
                borderBottom: '1px solid rgba(255,107,157,0.1)',
                display: 'flex', alignItems: 'center', gap: 12,
              }}>
                <div style={{
                  width: 40, height: 40, borderRadius: '50%',
                  background: 'linear-gradient(135deg, #ff6b9d, #a855f7)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 18,
                }}>🌙</div>
                <div>
                  <div style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: 14, color: '#fff9fb' }}>
                    Fiza 💕
                  </div>
                  <div style={{ fontFamily: 'Nunito, sans-serif', fontSize: 11, color: '#9b7ba8' }}>
                    Active late at night
                  </div>
                </div>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: 12, color: '#9b7ba8' }}>
                  📞 📹
                </div>
              </div>

              {/* Messages */}
              <div style={{
                padding: '16px', display: 'flex', flexDirection: 'column', gap: 10,
                maxHeight: 380, overflowY: 'auto',
              }}>
                <div style={{
                  textAlign: 'center', padding: '6px 16px',
                  background: 'rgba(255,107,157,0.08)', borderRadius: 50, margin: '0 auto',
                  fontFamily: 'Nunito, sans-serif', fontSize: 11, color: '#9b7ba8',
                }}>
                  🌙 Late Night, 22 June 2025
                </div>

                {chats.map((c, i) => (
                  <div key={i} style={{
                    display: 'flex',
                    justifyContent: c.side === 'sent' ? 'flex-end' : 'flex-start',
                    animation: `slideInBubble 0.5s ease forwards`,
                    animationDelay: `${c.delay}s`,
                    opacity: 0,
                  }}>
                    <div>
                      <div style={{
                        maxWidth: 200, padding: '10px 14px',
                        borderRadius: c.side === 'sent' ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
                        background: c.side === 'sent' ?
                          'linear-gradient(135deg, #a855f7, #7c3aed)' :
                          '#2d1f4a',
                        color: '#fff9fb',
                        fontFamily: 'Nunito, sans-serif', fontSize: 13, lineHeight: 1.5,
                      }}>
                        {c.text}
                      </div>
                      <div style={{
                        fontFamily: 'Nunito, sans-serif', fontSize: 10, color: '#9b7ba8',
                        marginTop: 3, textAlign: c.side === 'sent' ? 'right' : 'left',
                        paddingInline: 4,
                      }}>
                        {c.time} {c.side === 'sent' && '✓✓'}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Input */}
              <div style={{
                padding: '12px 16px',
                borderTop: '1px solid rgba(255,107,157,0.1)',
                display: 'flex', gap: 10, alignItems: 'center',
              }}>
                <div style={{
                  flex: 1, padding: '10px 16px',
                  background: 'rgba(255,107,157,0.06)',
                  border: '1px solid rgba(255,107,157,0.15)',
                  borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 13,
                  color: '#9b7ba8',
                }}>Message...</div>
                <div style={{ fontSize: 20, cursor: 'pointer' }}>❤️</div>
              </div>
            </div>
          </div>

          {/* Text side */}
          <div>
            <div className="section-badge">
              <span>🌙</span> Chapter 3
            </div>
            <h2 style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 800,
              fontSize: 'clamp(32px, 6vw, 56px)', lineHeight: 1.15, marginBottom: 8,
            }}>
              Late Night <span className="gradient-text">Talks</span>
            </h2>
            <div className="section-divider" />
            <div style={{
              display: 'inline-flex', alignItems: 'center', gap: 8,
              padding: '8px 18px',
              background: 'rgba(168,85,247,0.08)',
              border: '1px solid rgba(168,85,247,0.2)',
              borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 14,
              color: '#d8b4fe', marginBottom: 24,
            }}>
              🌙 Started 22 June 2025
            </div>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
              color: '#9b7ba8', marginBottom: 20,
            }}>
              When the world went quiet and the stars came out, Hassan and Fiza found something magical — their late-night conversations. While everyone else slept, these two were wide awake, sharing secrets, dreams, and endless laughs. 🌟
            </p>
            <p style={{
              fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
              color: '#9b7ba8', marginBottom: 32,
            }}>
              Those hours past midnight were sacred. Every "you still awake?" turned into hours of the most honest, beautiful conversations — the kind that only happen under a moonlit sky. 🌙💫
            </p>

            {/* Stats */}
            <div style={{
              display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)',
              gap: 16, marginBottom: 32,
            }}>
              {[
                { icon: '🌙', val: '2 AM+', label: 'Average' },
                { icon: '💬', val: '∞', label: 'Messages' },
                { icon: '🌟', val: 'Daily', label: 'Streak' },
              ].map(s => (
                <div key={s.label} style={{
                  background: 'rgba(168,85,247,0.08)',
                  border: '1px solid rgba(168,85,247,0.15)',
                  borderRadius: 16, padding: '16px 12px', textAlign: 'center',
                }}>
                  <div style={{ fontSize: 22, marginBottom: 6 }}>{s.icon}</div>
                  <div style={{
                    fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: 18,
                    color: '#d8b4fe',
                  }}>{s.val}</div>
                  <div style={{ fontFamily: 'Nunito, sans-serif', fontSize: 12, color: '#9b7ba8' }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}